/**
 * What a doctor's contact details open when they are pressed. The request of
 * 6 October 2026 (second), item 5: the mobile rings, the email writes, the
 * website opens.
 *
 * The three are free text, typed by somebody at a desk, so each is made into
 * an address here and nowhere else.
 */

/** The scheme a website opens with when what was typed has none. */
const WEB_SCHEME = 'https:';

/** A mobile as a number to ring: its digits and a leading plus, and none of the spacing it was typed with. */
export function telHref(mobile: string): string {
  return `tel:${mobile.replace(/[^\d+]/g, '')}`;
}

export function mailHref(email: string): string {
  return `mailto:${email.trim()}`;
}

/**
 * A website as an address a browser opens. "roesmile.example" was typed far
 * more often than a full address, and as a link it would be read as a page of
 * this app, so it is given a scheme. Only the two web schemes are taken as
 * they stand: anything else typed in front of a colon is treated as part of a
 * name and opens as a web address like the rest, never as a script.
 */
export function webHref(website: string): string {
  const text = website.trim();
  return /^https?:\/\//i.test(text) ? text : `${WEB_SCHEME}//${text}`;
}
